// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iYNF","title":"styles_title__17RZV"};